var SBTDPopup = function(elementId, options) {
  	
  this.el = null;
  this.timer = null;
  
  this.options = {
    
  };
  
  this.init = function(elementId, options) {

    this.el = $('#' + elementId);
  	if (this.el.length == 0) {
    	return;
  	}
    
    this.options = $.extend({}, this.options, options || {});
  
   
    
    
    this.el.find('.custom-get-discount').on('click', this.showForm.bind(this));
    this.el.find('.pay-more-link').on('click', this.hidePopup.bind(this));
    this.el.find('.close-button').on('click', this.hidePopup.bind(this));
    
    this.el.find('.send-popup').on('click', this.subscribe.bind(this));
    
    //var cookieVal = readCookie('sbtd-popup');
    //console.log(cookieVal);
    
    //Show popup on cookie
    /*
    if (cookieVal == null) {
      setTimeout(this.showPopup.bind(this), 5000);
      createCookie('sbtd-popup', '1', 7);
    }*/
    

  };
  
  this.clickAwayCheck = function(event) {
    var target = $(event.target);
    var targetClass = target.attr('class').replace("Hidden", "").trim();
    
    var inParent = this.el.find('.' + targetClass).length > 0;
    var elId = this.el.attr('id');
    
    if (!inParent) {
      this.hidePopup();
    }
  };
  
  
  this.showForm = function() {
    this.el.find('.custom-get-discount').addClass('Hidden');
    this.el.find('.form-popup-signup').removeClass('Hidden');
    this.el.find('.pay-more-link').addClass('Hidden');
    
  };
  
  this.hidePopup = function() {
    this.el.addClass('Hidden');
    
    $(window).off('click', 'popupAwayClick', this.clickAwayCheck.bind(this));
  };
  
  this.showPopup = function() {
    this.el.removeClass('Hidden');
    
    this.el.find('.custom-get-discount').removeClass('Hidden');
    
    this.el.find('.pay-more-link').removeClass('Hidden');
    this.el.find('.alert').addClass('Hidden');
    
    $(window).on('click', 'popupAwayClick', this.clickAwayCheck.bind(this));
  };
  
  
  this.subscribe = function() {
    newsletterShowLoading();
    var eml = this.el.find('input.email').val();
    
    var errorBox = this.el.find('.alert');
    var form = this.el.find('.form-popup-signup');
    
    jQuery.ajax({
          contentType: "application/json",
      		type: 'GET',
      		url: "https://app.bumpgirl.net/mailchimp/popup/submitAPI",
          data: {email: eml}
    	})
    	.done(function(response) {
          if (response.errors == false) {
            errorBox.removeClass('Hidden');
            errorBox.removeClass('alert-error');
            errorBox.html("Thanks for signing up, please check your email");
            form.addClass('Hidden');
    		
            ga('send', {
              hitType: 'event',
              eventCategory: 'Coupon',
              eventAction: 'Email Capture',
              eventLabel: '15 Off'
            });
            localStorage.setItem('subscribedUser', '1');
            newsletterHideLoading();
          } else {
            
            errorBox.removeClass('Hidden');
            errorBox.addClass('alert-error');
           	errorBox.html(response.error.message);
            newsletterHideLoading();
          }

      
    	}).fail(function(obj, res) {
          if (typeof obj.responseText != 'undefined') {
            var resp = JSON.parse(obj.responseText);
            var msg = resp.errors.message[0];
            
            errorBox.removeClass('Hidden');
            errorBox.addClass('alert-error');
            errorBox.html(msg);
          }
			newsletterHideLoading();
    	});
    
    
  }
  this.init(elementId, options);
}

function newsletterShowLoading () {
	$('.email').prop('disabled', true);
  	$('.send-popup').prop('disabled', true);
  	$('.send-popup').css('visibility', 'hidden');
  	$('.popup-loader').css('display', 'block');
  
}

function newsletterHideLoading () {
	$('.email').prop('disabled', false);
  	$('.send-popup').prop('disabled', false);
  	$('.send-popup').css('visibility', 'visible');
  	$('.popup-loader').css('display', 'none');
  	
}

/*
function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
*/


var sitePopup = null;

// OPEN POPUP WIDTH STICKY BUTTON
jQuery(document).ready(function() {
  sitePopup = new SBTDPopup('SBTD_Popup_Box');
   $('#stickyButtonPopup').on('click', function() {sitePopup.showPopup(); });
});